import * as React from "react";
import Container from "./styled";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { Fade } from "react-awesome-reveal";

export default function CarouselBannerMobile({ hidden, togglePopup }) {
  return (
    <Container hidden={hidden}>
      <Fade
        delay={200}
        duration={800}
        triggerOnce={true}
        className="pasosContainer"
      >
        {/* Carousel */}
        <Carousel
          showStatus={false}
          showIndicators={true}
          showThumbs={false}
          showArrows={true}
          width="100%"
          infiniteLoop={true}
          autoPlay
          interval={7000}
          swipeable={false}
        >
          <div>
            {/* Imagen 1 */}
            <img src="images/home/carousel/1Mobile.png" />
          </div>
          <div>
            {/* Imagen 2 */}
            <img src="images/home/carousel/1Mobile.png" />
          </div>
          <div>
            {/* Referidos */}
            <a onClick={togglePopup}>
              <img src="images/home/carousel/ReferidosMobile.png" />
            </a>
          </div>
          {/* Agregar mas imagenes dentro de un div aca, deben ser de 1274x200px*/}
        </Carousel>
      </Fade>
    </Container>
  );
}
